import { render, staticRenderFns } from "./collect-analysis.vue?vue&type=template&id=5b11152f&scoped=true"
import script from "./collect-analysis.vue?vue&type=script&lang=ts"
export * from "./collect-analysis.vue?vue&type=script&lang=ts"
import style0 from "./collect-analysis.vue?vue&type=style&index=0&id=5b11152f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b11152f",
  null
  
)

export default component.exports